var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorporateFare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_188_62",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 39
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.407959,
    y: 0.967773,
    width: 38.0013,
    height: 38.0013,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_188_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.57471 34.2189V5.7179H19.4086V12.0515H35.2425V34.2189H3.57471ZM6.74149 31.0521H16.2418V27.8853H6.74149V31.0521ZM6.74149 24.7186H16.2418V21.5518H6.74149V24.7186ZM6.74149 18.385H16.2418V15.2182H6.74149V18.385ZM6.74149 12.0515H16.2418V8.88467H6.74149V12.0515ZM19.4086 31.0521H32.0757V15.2182H19.4086V31.0521ZM22.5754 21.5518V18.385H28.9089V21.5518H22.5754ZM22.5754 27.8853V24.7186H28.9089V27.8853H22.5754Z",
    fill: "#33475B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateFare);
export default __webpack_public_path__ + "static/media/corporate_fare.4f4feeafde2c279c55cb248c2a5af50c.svg";
export { ForwardRef as ReactComponent };